import { apiClient } from '@/lib/api'

const STREETS_BASE = '/v1/streets'

/**
 * Street Types API
 */
export const streetTypesApi = {
  getAll: (params = {}) => apiClient.get(`${STREETS_BASE}/street-types/`, { params }),
  getById: (id) => apiClient.get(`${STREETS_BASE}/street-types/${id}/`),
  create: (data) => apiClient.post(`${STREETS_BASE}/street-types/`, data),
  update: (id, data) => apiClient.put(`${STREETS_BASE}/street-types/${id}/`, data),
  delete: (id) => apiClient.delete(`${STREETS_BASE}/street-types/${id}/`),
}

/**
 * Districts Big API (Райони міста)
 */
export const districtsBigApi = {
  getAll: (params = {}) => apiClient.get(`${STREETS_BASE}/districts-big/`, { params }),
  getById: (id) => apiClient.get(`${STREETS_BASE}/districts-big/${id}/`),
  create: (data) => apiClient.post(`${STREETS_BASE}/districts-big/`, data),
  update: (id, data) => apiClient.put(`${STREETS_BASE}/districts-big/${id}/`, data),
  delete: (id) => apiClient.delete(`${STREETS_BASE}/districts-big/${id}/`),
}

/**
 * Districts API (Мікрорайони)
 */
export const districtsApi = {
  getAll: (params = {}) => apiClient.get(`${STREETS_BASE}/districts/`, { params }),
  getById: (id) => apiClient.get(`${STREETS_BASE}/districts/${id}/`),
  create: (data) => apiClient.post(`${STREETS_BASE}/districts/`, data),
  update: (id, data) => apiClient.put(`${STREETS_BASE}/districts/${id}/`, data),
  delete: (id) => apiClient.delete(`${STREETS_BASE}/districts/${id}/`),
}

/**
 * Subway API (Станції метро)
 */
export const subwayApi = {
  getAll: (params = {}) => apiClient.get(`${STREETS_BASE}/subway/`, { params }),
  getById: (id) => apiClient.get(`${STREETS_BASE}/subway/${id}/`),
  create: (data) => apiClient.post(`${STREETS_BASE}/subway/`, data),
  update: (id, data) => apiClient.put(`${STREETS_BASE}/subway/${id}/`, data),
  delete: (id) => apiClient.delete(`${STREETS_BASE}/subway/${id}/`),
}

/**
 * Streets API (Вулиці)
 */
export const streetsApi = {
  getAll: (params = {}) => apiClient.get(`${STREETS_BASE}/streets/`, { params }),
  getById: (id) => apiClient.get(`${STREETS_BASE}/streets/${id}/`),
  create: (data) => apiClient.post(`${STREETS_BASE}/streets/`, data),
  update: (id, data) => apiClient.put(`${STREETS_BASE}/streets/${id}/`, data),
  delete: (id) => apiClient.delete(`${STREETS_BASE}/streets/${id}/`),
}
